@if (useLazyLoad || areProductsLoaded) {
  <sd-cross-sell #crossSellComponent
    [isSSR]="isSSR"
    [products]="products"
    [dynamicContentShowMore]="dynamicContentShowMore"
    [size]="layout === orientationEnum.row ? sizesEnum.m : sizesEnum.s"
    [isEmbedded]="isEmbedded"
    [showMoreDesktop]="showMoreDesktop"
    [titleLevel]="3"
    [twicPicsAutoSize]="!isFirst"
    [isLoading]="useLazyLoad && !areProductsLoaded"
    (swiperInfo)="onSwiperInfo($event)"
    (slidePrev)="onSlidePrev($event)"
    (slideNext)="onSlideNext($event)"
    (cart)="addToCart($event)"
    (notify)="notifyMe($event)"
    (productClicked)="onProductClick($event)"
    (productSellerModal)="openSellerModal()"
    (reviewsSeeAllClicked)="onReviewsSeeAllClicked($event)"
    (openRecommendedPriceModal)="openRecommendedPriceModal()"
    [brand]="brandCorner"
  />
}

<sd-product-seller-modal
  [(isOpened)]="isOpenedSellerModal"
/>

<wc-product-notification-modal
  [productCode]="notifyProduct"
  [productName]="notifyProductName"
  [(notifyModalOpened)]="notifyModalOpened"
/>

<wc-omnibus-recommended-price-modal
  [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal"
/>
